import {Component, Input, ViewChild, NgZone, OnInit} from '@angular/core';
import {MapsAPILoader, AgmMap} from '@agm/core';
import {GoogleMapsAPIWrapper} from '@agm/core';
import {FormControl, FormGroup} from '@angular/forms';
import {Project} from '../../../../../shared/classes/project/project';
import {timer} from 'rxjs/index';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {StatesService} from '../../../../../shared/services/state/states.service';

declare var google: any;

interface Marker {
    lat: number;
    lng: number;
    label?: string;
    draggable: boolean;
}

interface Location {
    lat: number;
    lng: number;
    viewport?: Object;
    zoom: number;
    place?: string;
    street?: string;
    country?: string;
    zipcode?: string;
    city?: string;
    marker?: Marker;
}

@Component({
    selector: 'app-project-address',
    templateUrl: './project-address.component.html',
    styleUrls: ['./project-address.component.css']
})
export class ProjectAddressComponent implements OnInit {

    markerDragEnd(m: google.maps.MouseEvent, $event: any) {
        this.location.marker.lat = m.latLng.lat();
        this.location.marker.lng = m.latLng.lng();
        this.findAddressByCoordinates();
    }

    public showSpinner: boolean;
    public geocoder: any;
    public location: Location = {
        lat: 48.856614,
        lng: 2.3522219,
        marker: {
            lat: 48.856614,
            lng: 2.3522219,
            draggable: true
        },
        zoom: 3,
        viewport: {}
    };
    public toggleTypeMap: boolean = true;
    public errorCounter: number = 0;
    public mapReady: boolean = false;
    public fitBounds: boolean = false;
    @ViewChild(AgmMap) map: AgmMap;
    @Input('project') project: Project;
    @Input('projectAddressForm') projectAddressForm: FormGroup;
    @Input('readOnly') readOnly: boolean = false;
    @Input() disableEditionButton: boolean;

    constructor(public mapsApiLoader: MapsAPILoader,
                private zone: NgZone,
                private wrapper: GoogleMapsAPIWrapper,
                private toastr: ToastrService,
                private translate: TranslateService,
                private stateService: StatesService) {

        this.mapsApiLoader = mapsApiLoader;
        this.zone = zone;
        this.wrapper = wrapper;
        this.mapsApiLoader.load().then(() => {
            this.errorCounter = 0;
            this.geocoder = new google.maps.Geocoder();
            this.mapReady = true;
            this.updateOnMap();
        });

    }

    ngOnInit() {
        const source = timer(1000);
        const subscribe = source.subscribe(val => {
        });
    }

    updateOnMap() {

        let full_address: string = this.projectAddressForm.value.place || '';
        if (this.projectAddressForm.value.street) {
            full_address = full_address + ' ' + this.projectAddressForm.value.street;
        }
        if (this.projectAddressForm.value.city) {
            full_address = full_address + ' ' + this.projectAddressForm.value.city;
        }
        if (this.projectAddressForm.value.country) {
            full_address = full_address + ' ' + this.projectAddressForm.value.country;
        }

        if (full_address) {
            this.findLocation(full_address);
        } else {
            this.toastError();
        }
    }

    resetMap() {
        this.errorCounter = 0;
        this.projectAddressForm.reset();
        this.location = {
            lat: 48.856614,
            lng: 2.3522219,
            marker: {
                lat: 48.856614,
                lng: 2.3522219,
                draggable: true
            },
            zoom: 3
        };
        this.updateOnMap();
        if (this.project.id) {
            this.stateService.reloadProjectCrud.next();
        }
    }


    findLocation(address = null) {
        this.showSpinner = true;
        if (!this.geocoder) {
            this.geocoder = new google.maps.Geocoder();
        }
        this.geocoder.geocode({
            'address': address
        }, (results, status) => {
            if (status == google.maps.GeocoderStatus.OK) {

                let street: string = '';
                let zipcode: string = '';
                let city: string = '';
                let country: string = '';
                let place: string = '';

                for (let i = 0; i < results[0].address_components.length; i++) {
                    let types = results[0].address_components[i].types;

                    if (types.indexOf('street_number') != -1) {
                        place += results[0].address_components[i].long_name;
                    }

                    if (types.indexOf('route') != -1) {
                        place += ', ' + results[0].address_components[i].long_name;
                    }

                    if (types.indexOf('locality') != -1) {
                        city = results[0].address_components[i].long_name;
                    }
                    if (types.indexOf('country') != -1) {
                        country = results[0].address_components[i].long_name;
                    }
                    if (types.indexOf('postal_code') != -1) {
                        zipcode = results[0].address_components[i].long_name;
                    }
                    if (types.indexOf('administrative_area_level_1') != -1) {
                        street = results[0].address_components[i].long_name;
                    }
                }

                this.projectAddressForm.patchValue({
                    place: place,
                    street: street,
                    zipcode: zipcode,
                    city: city,
                    country: country,
                });

                if (results[0].geometry.location) {
                    this.location.lat = results[0].geometry.location.lat();
                    this.location.lng = results[0].geometry.location.lng();
                    this.location.marker.lat = results[0].geometry.location.lat();
                    this.location.marker.lng = results[0].geometry.location.lng();
                    this.location.marker.draggable = true;
                    this.location.viewport = results[0].geometry.viewport;

                    this.projectAddressForm.patchValue({

                        latitude: results[0].geometry.location.lat(),
                        longitude: results[0].geometry.location.lng(),

                    });
                    if (this.map) {
                        this.map.triggerResize();
                    }
                }

                this.showSpinner = false;
                this.fitBounds = true;
                this.projectAddressForm.patchValue({
                    zoom: this.location.zoom
                });
            } else {
                this.toastError();
            }
        });
    }

    findAddressByCoordinates() {

        this.geocoder.geocode({
            'location': {
                lat: this.location.marker.lat,
                lng: this.location.marker.lng
            }
        }, (results, status) => {
            this.decomposeAddressComponents(results);
        });
    }


    decomposeAddressComponents(addressArray) {
        if (addressArray.length == 0) {
            return false;
        }
        let address = addressArray[0].address_components;


        let place: string = '';
        let street: string = '';
        let zipcode: string = '';
        let city: string = '';
        let country: string = '';


        for (let element of address) {
            if (element.length == 0 && !element['types']) {
                continue;
            }

            if (element['types'].indexOf('street_number') > -1) {
                place = element['long_name'];
                continue;
            }
            if (element['types'].indexOf('route') > -1) {
                place += ', ' + element['long_name'];
                continue;
            }
            if (element['types'].indexOf('locality') > -1) {
                city = element['long_name'];
                continue;
            }
            if (element['types'].indexOf('administrative_area_level_1') > -1) {
                street = element['long_name'];
                continue;
            }
            if (element['types'].indexOf('country') > -1) {
                country = element['long_name'];
                continue;
            }
            if (element['types'].indexOf('postal_code') > -1) {
                zipcode = element['long_name'];
                continue;
            }
        }

        this.projectAddressForm.patchValue({
            place: place,
            street: street,
            zipcode: zipcode,
            city: city,
            country: country

        });

    }

    private toastError() {
        if (this.errorCounter !== 0) {
            this.toastr.error(this.translate.instant('GOOGLE_MAP_UNABLE_TO_LOCATE'), this.translate.instant('ERROR'));
        }
        this.errorCounter += 1;
        this.showSpinner = false;
    }

}
